import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LobsterMascot from './LobsterMascot.jsx';
import MascotMenu from './MascotMenu.jsx';
import { useTranslation } from '../i18n/I18nContext.jsx';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';

export default function PublicNav() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const lp = useLocalizedPath();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: lp('/'), label: t('nav.home') },
    { to: lp('/pricing'), label: t('nav.pricing') },
    { to: lp('/contact'), label: t('nav.contact') },
  ];

  return (
    <nav className="pub-nav" aria-label={t('nav.ariaLabel')}>
      <div className="pub-nav-inner">
        <div className="pub-nav-logo-wrap">
          <button
            className="mascot-menu-btn"
            onClick={() => setMenuOpen(v => !v)}
            aria-expanded={menuOpen}
            aria-haspopup="true"
            aria-label={t('nav.menuAriaLabel')}
          >
            <LobsterMascot size={36} />
            <span className="pub-nav-brand">Claw-dius</span>
          </button>
          <MascotMenu open={menuOpen} onClose={() => setMenuOpen(false)} authenticated={false} />
        </div>

        <ul className="pub-nav-links" role="list">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`pub-nav-link${pathname === to ? ' active' : ''}`}
                aria-current={pathname === to ? 'page' : undefined}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <Link to={lp('/login')} className="btn btn-primary pub-nav-cta">
          {t('nav.getStarted')}
        </Link>
      </div>
    </nav>
  );
}
